<div class="wrapper">
  <swiper-container
    #swiperContainer
  >
    <ng-container *ngFor="let slide of slides">
      <swiper-slide [ngClass]="{ 'move-to-top': moveToTop }">
        <ng-container [ngTemplateOutlet]="slide.templateRef"></ng-container>
      </swiper-slide>
    </ng-container>
  </swiper-container>

  <div class="controls">
    <span *ngIf="!isLastPanel" class="next-btn" (click)="slideNext()">{{nextButtonName}}</span>
    <span *ngIf="isLastPanel" class="next-btn" (click)="onFinalizationButtonClick.next()">{{finalizationButtonName}}</span>
  </div>
</div>


